import React from 'react'
import { formatCurrency } from '../../../helpers'

const Summary = ({
    working,
    book,
    copies,
    destination,
    onBuyClick
}) => {

  const postage = copies > 0
    ? Math.min(copies * destination.fee, destination.maxFee || 9999)
    : destination.fee

  const amount = copies &&
    destination &&
    (copies * book.price.amount) + postage

  return <div className="row">
    <div className="col-md">
      {amount > 0 &&
        <p>
          <b>{copies} {copies === 1 ? "copy" : "copies"}</b> @ ${formatCurrency(book.price.amount)} ea,
          plus <b>${formatCurrency(postage)}</b> (<abbr title="Postage &amp; Packaging">P&amp;P</abbr>)
          to <b className="text-nowrap">{destination.label}</b> is <b>${formatCurrency(amount)} {book.price.currency}</b>.
        </p>
      }
    </div>

    <div className="col-md-auto">
      <button
        className={"btn btn-lg " + (amount > 0 ? "btn-danger" : "btn-dark")}
        title={amount > 0 ? "Click to check out" : "Select destination to check out"}
        onClick={onBuyClick}
        disabled={!amount || working}
      >
        {working &&
          <i className="fas fa-spinner fa-spin mr-2" />
        }
        {working ? "Completing…" : "Buy Now"}
      </button>
    </div>
  </div>
}

export default Summary
